import { render, staticRenderFns } from "./StaticRoutesTab.vue?vue&type=template&id=67d4bd38&scoped=true&"
import script from "./StaticRoutesTab.vue?vue&type=script&lang=js&"
export * from "./StaticRoutesTab.vue?vue&type=script&lang=js&"
import style0 from "./StaticRoutesTab.vue?vue&type=style&index=0&id=67d4bd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4bd38",
  null
  
)

export default component.exports